import { useParams } from 'react-router-dom';

import ParceriaDetail from '../../features/parcerias/layouts/detail';
import ParceriasOverview from '../../features/parcerias/layouts/overview';

// TSS vite/01 — thin page. Mounts the parcerías feature: the list, or one
// recipient's dashboard when the URL carries an id. Guarded by <AuthRoute>.

export default function ParceriasPage() {
    const { recipientId } = useParams();
    if (recipientId) return <ParceriaDetail recipientId={recipientId} />;
    return <ParceriasOverview />;
}
